export class TileModel {
  id?: number;
  title: string;
  route: string;
  redirectUrlAfterClick?: string;
  roles?: string[];
  imageUrl: string;
}
